// @flow
import { PersonsActionTypes } from './constants';

type PersonsAction = { type: string, payload: {} | string };

// common success
export const personsApiResponseSuccess = (actionType: string, data: any): PersonsAction => ({
    type: PersonsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const personsApiResponseError = (actionType: string, error: string): PersonsAction => ({
    type: PersonsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getPerson = (id: string): PersonsAction => ({
    type: PersonsActionTypes.GET_PERSON,
    payload: { id },
});

export const addPerson = (person: any): PersonsAction => ({
    type: PersonsActionTypes.ADD_PERSON,
    payload: person
})
export const updatePerson = (person: any): PersonsAction => ({
    type: PersonsActionTypes.UPDATE_PERSON,
    payload: person
})
export const deletePerson = (id: string): PersonsAction => ({
    type: PersonsActionTypes.DELETE_PERSON,
    payload: { id }
})

export const listPersons = (params: any): PersonsAction => ({
    type: PersonsActionTypes.LIST_PERSONS,
    payload: params,
});


export const resetPersons = (): PersonsAction => ({
    type: PersonsActionTypes.RESET,
    payload: {},
});

